<script setup lang="ts">
import { type RichTextEditor } from '~/components/Aggregates/RichTextEditor/types';
const props = defineProps<RichTextEditor & { noContainer?: Boolean }>();
</script>

<template>
  <div
    class="flex flex-col has-[table]:overflow-x-auto"
    :class="{
      container: !props.noContainer
    }"
  >
    <div class="rich-text-editor" v-if="props.properties.text" v-html="props.properties.text.markup"></div>
  </div>
</template>

<style scoped>
.rich-text-editor:deep() {
  h1 {
    @apply text-4xl font-bold;
  }

  h2 {
    @apply mt-4 text-3xl font-semibold;
  }

  h3 {
    @apply mt-2 text-2xl font-medium;
  }

  h4 {
    @apply mt-1 text-xl font-normal;
  }

  p {
    @apply mt-2 text-base font-normal;
  }

  a {
    @apply underline hover:text-tangerine;
  }

  table {
    @apply table w-full caption-bottom text-sm;

    tbody {
      border: inherit;
    }

    tr {
      @apply transition-colors;
      border: inherit;
    }

    td {
      @apply p-4 align-middle [&:has([role=checkbox])]:pr-0;
      border: inherit;
    }

    th {
      @apply h-12 p-4 text-left align-middle text-xs font-bold uppercase text-stormcloud [&:has([role=checkbox])]:pr-0;
      border: inherit;
    }
  }

  ol {
    @apply list-inside list-decimal pl-4;
  }

  ul {
    @apply list-inside list-disc pl-4;
  }
}
</style>
